import { type KbDiffLine } from '@gb-ticket/shared-types';

import { cn } from '@/lib/utils';

export function KbDiffView({ title, lines }: { title: string; lines: KbDiffLine[] }) {
  if (
    lines.length === 0 ||
    lines.every((line) => line.type === 'equal' && line.text.length === 0)
  ) {
    return null;
  }
  const changed = lines.some((line) => line.type !== 'equal');
  if (!changed && lines.length === 1 && !lines[0]?.text) {
    return null;
  }
  return (
    <div className="space-y-1">
      <p className="text-xs font-medium text-muted-foreground">{title}</p>
      <pre className="max-h-64 overflow-auto rounded-md border bg-muted/40 p-2 text-xs leading-5">
        {lines.map((line, index) => (
          <span
            key={`${line.type}-${index}`}
            className={cn(
              'block whitespace-pre-wrap',
              line.type === 'add' && 'bg-emerald-500/15 text-emerald-900 dark:text-emerald-200',
              line.type === 'remove' && 'bg-red-500/15 text-red-900 line-through dark:text-red-200',
            )}
          >
            {line.type === 'add' ? '+ ' : line.type === 'remove' ? '− ' : '  '}
            {line.text || ' '}
          </span>
        ))}
      </pre>
    </div>
  );
}
